"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TreeManager = void 0;
var React = __importStar(require("react"));
var react_1 = require("react");
var TreeItemChildren_1 = require("../treeItem/TreeItemChildren");
var useFocusWithin_1 = require("./useFocusWithin");
var useTreeKeyboardBindings_1 = require("./useTreeKeyboardBindings");
var SearchInput_1 = require("../search/SearchInput");
var Tree_1 = require("./Tree");
var ControlledTreeEnvironment_1 = require("../controlledEnvironment/ControlledTreeEnvironment");
var DragAndDropProvider_1 = require("../controlledEnvironment/DragAndDropProvider");
var MaybeLiveDescription_1 = require("./MaybeLiveDescription");
var treeContainerStyle = {
    position: "relative",
};
var TreeManager = function () {
    var _a = (0, Tree_1.useTree)(), treeId = _a.treeId, rootItem = _a.rootItem, renderers = _a.renderers, treeInformation = _a.treeInformation;
    var _b = (0, ControlledTreeEnvironment_1.useTreeEnvironment)(), setActiveTree = _b.setActiveTree, items = _b.items, canSearch = _b.canSearch;
    var containerRef = (0, react_1.useRef)(null);
    var _c = (0, DragAndDropProvider_1.useDragAndDrop)(), abortProgrammaticDrag = _c.abortProgrammaticDrag, onDragLeaveTreeHandler = _c.onDragLeaveTreeHandler;
    (0, useTreeKeyboardBindings_1.useTreeKeyboardBindings)();
    (0, useFocusWithin_1.useFocusWithin)(containerRef.current, function () {
        setActiveTree(treeId);
    }, function () {
        setActiveTree(function (oldTreeId) { return (oldTreeId === treeId ? undefined : oldTreeId); });
    });
    var rootChildren = items[rootItem].children;
    var treeChildren = (React.createElement(React.Fragment, null,
        React.createElement(MaybeLiveDescription_1.MaybeLiveDescription, null),
        React.createElement(TreeItemChildren_1.TreeItemChildren, { depth: 0, parentId: items[rootItem].index }, rootChildren !== null && rootChildren !== void 0 ? rootChildren : []),
        canSearch && React.createElement(SearchInput_1.SearchInput, { containerRef: containerRef.current })));
    var containerProps = {
        onDragLeave: onDragLeaveTreeHandler,
        onMouseDown: abortProgrammaticDrag,
        ref: containerRef,
        style: treeContainerStyle,
        role: "tree",
        "aria-label": !treeInformation.treeLabelledBy ? treeInformation.treeLabel : undefined,
        "aria-labelledby": treeInformation.treeLabelledBy,
        // @ts-expect-error non-standard attribute.
        "data-rct-tree": treeId,
    };
    return renderers.renderTreeContainer({
        children: treeChildren,
        info: treeInformation,
        containerProps: containerProps,
    });
};
exports.TreeManager = TreeManager;
